export default {"src":"/_next/static/media/beansprouts.b5269703.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};